import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Col, Row, Button, Form, Label, Input } from 'reactstrap';
import Select from 'react-select'; // React Select for dropdowns
import { addWorkOrder, getSebelUsers, getSolutions, getTeams, getWorkOrders } from 'store/actions'; // Actions for fetching and adding work orders
import Breadcrumb from 'components/Common/Breadcrumb2'; // Breadcrumb component
import { convertDateFormat, convertToDateOnly2 } from 'helpers/dateFormat_helper';
import WorkOrderReportTable from './WorkOrderReportTable';
import Cookies from 'js-cookie';
import { showError } from 'helpers/notification_helper';
import axiosInstance from 'pages/Utility/axiosInstance';

const OnGoingWorkOrderList = () => {
    const [isOpen, setIsOpen] = useState(false); // State to control the modal visibility
    const [selectedTeam, setSelectedTeam] = useState(null);
    const [workOrders, setWorkOrders] = useState();
    const [createdAt,setCreatedAt] = useState();
    const [selectedSolution, setSelectedSolution] = useState(null);
    const [selectedSebeleId, setSelectedSebeleId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [pageIndex, setPageIndex] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [sorting, setSorting] = useState([{ id: 'workOrderId', desc: true }]);
    const [searchTerm, setSearchTerm] = useState("");
    const [searchVal, setSearchVal] = useState("");
    const id = JSON.parse(Cookies.get('authUser'))?.userId

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    // Selectors to access Redux state
    const teams = useSelector((state) => state?.Team?.teams)
    const solutions = useSelector(state => state.Solution.solutions);
    const sebelUsers = useSelector(state => state.SebelUser.users);
    const teamsLoading = useSelector((state) => state.Team.loading);
    const solutionsLoading = useSelector((state) => state.Solution.loading);
    const sebelUsersLoading = useSelector((state) => state.SebelUser.loading);
    const error = useSelector((state) => state.WorkOrder.error);
    const cookieEndDate = Cookies.get('endDate');
    const cookieStartDate = Cookies.get('startDate');
    const cookieSelectedTeam = Cookies.get('selectedTeam') ? JSON.parse(Cookies.get('selectedTeam')) : "";
    const cookiePageUrl = Cookies.get('pageUrl');
    const cookieSelectedSolution = Cookies.get('selectedSolution');
    const cookieSebeleId = Cookies.get('selectedSebeleId');
    const cookieCreatedAt = Cookies.get('createdAt');
    const pageUrl = location.pathname

    // Fetch permissions from localStorage
    const permissions2 = JSON.parse(localStorage?.getItem('permissions'));

    // Sample team and status options (replace with actual data if available)
    const teamOptions = teams?.Data?.map(item => ({ label: item?.teamName, value: item?.teamId }))

    const getCurrentMonthRange = () => {
        const now = new Date();
        const firstDay = new Date(now.getFullYear(), now.getMonth(), 2);
        const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 1);

        const formatDate = (date) => date.toISOString().slice(0, 19); // Convert to YYYY-MM-DD format

        return {
            startDate: formatDate(firstDay),
            endDate: formatDate(lastDay),
        };
    };

    const [startDate, setStartDate] = useState(getCurrentMonthRange().startDate);
    const [endDate, setEndDate] = useState(getCurrentMonthRange().endDate);

    useEffect(() => {
        if (loading && cookieEndDate || cookieStartDate || cookieCreatedAt || cookieSelectedTeam || cookieSelectedSolution || cookieSebeleId ) return;
        dispatch(getTeams(true))
        dispatch(getSolutions());
        dispatch(getSebelUsers());
        
        const sortColId = sorting[0]?.id || 'workOrderNumber';
        const sortCol = getColumnIndex(sortColId);
        const sortDir = sorting[0]?.desc ? 'DESC' : 'ASC';
        
        dispatch(getWorkOrders(id, 'WorkOrder Started', convertDateFormat(startDate), convertDateFormat(endDate), selectedTeam?.value, selectedSolution, convertToDateOnly2(createdAt), selectedSebeleId, pageSize, pageIndex * pageSize, sortCol, sortDir, searchTerm));
    }, [dispatch, pageIndex, pageSize, sorting, searchTerm]);

    useEffect(() => {
        if (cookieEndDate && location?.state?.cameFromWorkOrders && pageUrl == cookiePageUrl) {
            setEndDate(cookieEndDate);
        }
        if (cookieStartDate && location?.state?.cameFromWorkOrders && pageUrl == cookiePageUrl) {
            setStartDate(cookieStartDate);
        }
        if (cookieSelectedTeam && location?.state?.cameFromWorkOrders && pageUrl == cookiePageUrl) {
            setSelectedTeam(cookieSelectedTeam);
        }
        if (cookieSelectedSolution && location?.state?.cameFromWorkOrders && pageUrl == cookiePageUrl) {
            setSelectedSolution(cookieSelectedSolution);
        }
        if (cookieSebeleId && location?.state?.cameFromWorkOrders && pageUrl == cookiePageUrl) {
            setSelectedSebeleId(cookieSebeleId);
        }
        if (cookieCreatedAt && location?.state?.cameFromWorkOrders && pageUrl == cookiePageUrl) {
            setCreatedAt(cookieCreatedAt);
        }
        if ((cookieEndDate || cookieStartDate || cookieCreatedAt || cookieSelectedTeam || cookieSelectedSolution || cookieSebeleId ) && location?.state?.cameFromWorkOrders && pageUrl == cookiePageUrl) {
            dispatch(getWorkOrders(id, 'WorkOrder Started', convertDateFormat(cookieStartDate), convertDateFormat(cookieEndDate), cookieSelectedTeam?.value, cookieSelectedSolution, convertToDateOnly2(cookieCreatedAt), cookieSebeleId));
        }
        Cookies.remove('endDate');
        Cookies.remove('startDate');
        Cookies.remove('selectedTeam');
        Cookies.remove('selectedStatus');
        Cookies.remove('pageUrl');
        Cookies.remove('selectedSolution');
        Cookies.remove('selectedSebeleId');
        Cookies.remove('createdAt');
    }, [location]);

    useEffect(() => {
        localStorage.setItem('endDate', endDate);
        localStorage.setItem('startDate', startDate);
        localStorage.setItem('selectedTeam', JSON.stringify(selectedTeam));
        localStorage.setItem('pageUrl', location?.pathname)
        localStorage.setItem('selectedSolution',selectedSolution)
        localStorage.setItem('selectedSebeleId',selectedSebeleId)
        localStorage.setItem('createdAt',createdAt)
    }, [endDate, startDate,  selectedTeam, location,selectedSolution,selectedSebeleId,createdAt])
 
    const getColumnIndex = (accessorKey) => {
        const mapping = {
            'workOrderNumber': 0,
            'teamName': 1,
            'createdBy': 2,
            'solution': 3,
            'createdAt': 4,
            'scheduledStartDateTime': 5,
            'scheduledEndDateTime': 6,
            'workOrderStatus': 7
        };
        return mapping[accessorKey] !== undefined ? mapping[accessorKey] : 0;
    };


    const handleSearch = () => {
        if (new Date(startDate) > new Date(endDate)) {
            showError("Start date can't be greater than end date"); // Show error alert
            return;
        }

        setPageIndex(0); // Reset to first page on search
        setSearchTerm(searchVal);

        const sortColId = sorting[0]?.id || 'workOrderNumber';
        const sortCol = getColumnIndex(sortColId);
        const sortDir = sorting[0]?.desc ? 'DESC' : 'ASC';
        
        dispatch(getWorkOrders(id, 'WorkOrder Started', convertDateFormat(startDate), convertDateFormat(endDate), selectedTeam?.value, selectedSolution, convertToDateOnly2(createdAt), selectedSebeleId, pageSize, 0, sortCol, sortDir, searchVal));
    };
    // Let's fix the above duplicate.

    return (
        <>
            <div className='page-content container-fluid'>
                <div className='d-flex justify-content-between align-items-center mx-3'>
                    <Breadcrumb
                        title="Ongoing Work Orders"
                        breadcrumbItems={[
                            { title: "Dashboard", link: `/dashboard` },
                            { title: "Ongoing Work Orders", link: '#' }
                        ]}
                    />
                    {/* {permissions2?.map(item => item?.permissionName)?.includes("Add Work Orders") && (
                        <Button
                            className='bg-primary text-white d-flex justify-content-center gap-1 align-items-center'
                            onClick={() => navigate(`/createWorkOrder`)}
                        >
                            <i className='ti-plus'></i> Add New
                        </Button>
                    )} */}
                </div>

                {/* Filters Section */}
                <div className='filters-section mx-3'>
                    <Form className="my-3">
                        <Row className="g-3">
                            {/* Start Date */}
                            <Col xs={6} md={3}>
                                <Label for="startDate">Start Date</Label>
                                <Input
                                    type="datetime-local"
                                    id="startDate"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                    style={{ height: "38px", border: "1px solid lightgray" }}
                                />
                            </Col>

                            {/* End Date */}
                            <Col xs={6} md={3}>
                                <Label for="endDate">End Date</Label>
                                <Input
                                    type="datetime-local"
                                    id="endDate"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                    style={{ height: "38px", border: "1px solid lightgray" }}
                                />
                            </Col>

                            {/* Created Date */}
                            <Col xs={6} md={3}>
                                <Label for="createdAt">Created Date</Label>
                                <Input
                                    type="date"
                                    id="createdAt"
                                    value={createdAt}
                                    onChange={(e) => setCreatedAt(e.target.value)}
                                    style={{ height: "38px", border: "1px solid lightgray" }}
                                />
                            </Col>

                            {/* Team Selector */}
                            <Col xs={6} md={3}>
                                <Label for="team">Team</Label>
                                <Select
                                    id="team"
                                    options={teamOptions}
                                    value={selectedTeam}
                                    isLoading={teamsLoading}
                                    onChange={setSelectedTeam}
                                    placeholder="Select Team"
                                    isClearable={true}
                                />
                            </Col>
                            {/* Work Order Solution Selector */}
                            <Col xs={6} md={3}>
                                <Label for="solution" className='mt-1'>Solution</Label>
                                <Select
                                    id="solution"
                                    options={solutions?.Data?.map(item=>({label:item?.solutionName,value:item?.solutionId}))}
                                    value={solutions?.Data?.map(item=>({label:item?.solutionName,value:item?.solutionId}))?.find(option => option?.value == selectedSolution)||""}
                                    isLoading={solutionsLoading}
                                    onChange={option => { setSelectedSolution(option?.value);}}
                                    placeholder="Select Solution"
                                    isClearable={true}
                                />
                            </Col>

                                <Col xs={6} md={3}>
                                <Label for="status" className='mt-1'>Siebel User ID</Label>
                                <Select
                                    id="status"
                                    options={sebelUsers?.Data?.map(item=>({label:item?.sabelUserId,value:item?.id}))}
                                    value={sebelUsers?.Data?.map(item=>({label:item?.sabelUserId,value:item?.id}))?.find(option => option?.value == selectedSebeleId)||""}
                                    isLoading={sebelUsersLoading}
                                    onChange={option => { setSelectedSebeleId(option?.value);}}
                                    placeholder="Select Siebel User ID"
                                    isClearable={true}
                                />
                            </Col>
                             {/* Global Search Input */}
                             <Col xs={6} md={3}>
                                <Label for="searchField" className='mt-1'>Search</Label>
                                <Input
                                    type="text"
                                    id="searchField"
                                    placeholder="Search..."
                                    value={searchVal}
                                    onChange={(e) => setSearchVal(e.target.value)}
                                    style={{ height: "38px", border: "1px solid lightgray" }}
                                />
                            </Col>

                            <Col xs={6} md={3} className='d-flex justify-start align-center'>
                                <Button color="primary mt-auto" style={{ marginBottom: '2px' }} onClick={handleSearch}>Search</Button>
                            </Col>
                        </Row>
                    </Form>
                </div>

                {/* Work Orders Table */}
                <WorkOrderReportTable 
                    loading={loading} 
                    List={workOrders?.Data} 
                    docName="Ongoing WorkOrder Report" 
                    pageIndex={pageIndex}
                    pageSize={pageSize}
                    sorting={sorting}
                    onPaginationChange={(state) => {
                        setPageIndex(state.pageIndex);
                        setPageSize(state.pageSize);
                    }}
                    onSortingChange={setSorting}
                    onGlobalFilterChange={setSearchTerm}
                />
            </div>
        </>
    );
};

export default OnGoingWorkOrderList;